import { WOMA_API_GATEWAY_NAME, WOMA_END_POINT, REGION, userPoolId, userPoolWebClientId } from '../constants/aws'

export const COGNITO = {
  // Auth: {
  //   mandatorySignIn: true,
  //   // identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  //   region,
  //   userPoolId,
  //   userPoolWebClientId,
  // },
  API: {
    endpoints: [
      {
        name: WOMA_API_GATEWAY_NAME,
        endpoint: WOMA_END_POINT,
        REGION,
      },
    ],
  },
}
